var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSecret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6vfaqiytua",
    d: "M5.042 3.538l.251-.66c.036-.093-.033-.194-.134-.194h-.697c.09-.195.139-.411.139-.64 0-.043-.002-.086-.006-.128.474-.094.773-.23.773-.382 0-.16-.327-.301-.838-.395-.11-.393-.326-.788-.488-.993-.113-.142-.31-.187-.473-.106l-.33.166c-.108.054-.235.054-.343 0L2.566.04c-.163-.081-.36-.036-.473.106-.162.205-.378.6-.488.993-.512.094-.838.236-.838.395 0 .152.298.288.772.382-.004.043-.005.086-.005.129 0 .228.05.444.139.639H.985c-.103 0-.173.105-.132.2l.274.64C.693 3.69.383 4.11.383 4.602v1.246c0 .159.13.288.288.288h4.793c.158 0 .287-.13.287-.288V4.601c0-.479-.293-.89-.709-1.063zM2.588 5.847l-.575-2.3.575.287.288.48-.288 1.533zm.959 0l-.288-1.534.288-.479.575-.287-.575 2.3zm.656-3.64c0 .001-.052.04-.062.07-.046.142-.084.294-.197.4-.121.111-.575.268-.767-.3-.034-.101-.185-.101-.22 0-.203.6-.67.388-.766.3-.114-.106-.152-.258-.198-.4-.01-.03-.061-.069-.061-.07-.007-.034-.012-.07-.015-.105-.004-.047.12-.044.133-.045.315-.028.626-.007.935.066.03.007.138.006.165 0 .308-.073.62-.094.935-.066.012 0 .136-.002.132.045-.002.035-.008.07-.014.106z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-734 -864) translate(734.425 864)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "08kzi8a88b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6vfaqiytua"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#6vfaqiytua"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A6A6A6",
    mask: "url(#08kzi8a88b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H6.135V6.135H0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSecret);
export default __webpack_public_path__ + "static/media/user-secret.53fdfe30c07c6d809be827762d8593ff.svg";
export { ForwardRef as ReactComponent };